<script setup>
import { inject, ref } from 'vue'

const { isBrowser } = inject('Shared')
const props = defineProps({
  items: { type: Array },
  slidesPerView: { type: [Number, String] },
  slidesPerGroup: { type: [Number, String] },
  spaceBetween: { type: Number, default: 0 },
  breakpoints: { type: [String, Object] },
  initialSlide: { type: Number, default: 0 },
  centeredSlides: { type: Boolean },
  autoplay: { type: Object },
  loop: { type: Boolean },
  freeMode: { type: Boolean },
  speed: { type: Number, default: 700 },
  freeModeMomentum: { type: Boolean },
  grabCursor: { type: Boolean }
})
const emit = defineEmits(['swiper', 'index'])
let Swiper
let SwiperSlide
let modules
if (isBrowser) {
  const swiperjsvue = require('swiper/vue')
  const swiperjs = require('swiper')
  Swiper = swiperjsvue.Swiper
  SwiperSlide = swiperjsvue.SwiperSlide
  modules = [swiperjs.Autoplay]
  require('swiper/css')
  require('swiper/css/autoplay')
}
const thumbsSwiper = ref(null)
const setThumbsSwiper = (swiper) => {
  thumbsSwiper.value = swiper
  emit('swiper', swiper)
}
const index = ref(0)
const onSlideChange = (e) => {
  if (thumbsSwiper.value) {
    index.value = e.realIndex
    emit('index', e.realIndex)
  }
}
</script>

<template lang="pug">
.full-width.relative-position
  swiper(
    v-if="isBrowser"
    :centeredSlides="centeredSlides ? centeredSlides : false"
    :centeredSlidesBounds="centeredSlides ? centeredSlides : false"
    :autoplay="autoplay ? autoplay : undefined"
    :slides-per-view='slidesPerView ? slidesPerView : 1'
    :space-between='spaceBetween ? spaceBetween : 0'
    :breakpoints="breakpoints"
    :initialSlide="initialSlide ? initialSlide : 0"
    :modules="modules ? modules : undefined"
    :speed="speed"
    :free-mode-momentum="freeModeMomentum"
    :loop="loop"
    :grabCursor="grabCursor"
    @slideChange="onSlideChange"
    @swiper="setThumbsSwiper"
  )
    slot(name="control" :items="items" :swiper="thumbsSwiper" :index="index")
    swiper-slide(v-for="(item, index) in items" :key="index")
      slot(name="item" :item="item" :index="index")
  slot(v-else-if="items && items[0]" name="item" :item="items[0]")
</template>

<style scoped lang="sass">

</style>
